import { TrackingEventType, useAnalytics, WalletCustody } from '@capsicum/common';
import { Text, useRouter } from '@capsicum/common-web';
import { type MyCollectible } from '@capsicum/features/digital-collectibles/shared';
import { useWalletCollectiblesLists } from '@capsicum/features/wallet/shared';
import styled from 'styled-components';

import { WalletCollectiblesList, WalletCollectiblesListSkeleton, WalletNoCollectiblesCard } from '../../ui';
import { WalletTabContainer } from '../wallet-tab-container';

export const DigitalCollectibles = () => {
	const { push } = useRouter();

	const analytics = useAnalytics();

	const { favoriteCollectibles, isLoading, otherCollectibles, texts } = useWalletCollectiblesLists(
		WalletCustody.Custodial
	);

	const handleClickDigitalCollectible = (collectible: MyCollectible) => {
		analytics.sendEvent(TrackingEventType.track, 'DigitalCollectibleCardClick', {
			item_id: collectible.summary?.collectibleId || ''
		});
		push(`/digital-collectibles/${collectible.summary?.collectibleId}`);
	};

	return (
		<WalletTabContainer>
			<S.Section>
				<S.Title variant="title5">{texts.title}</S.Title>
				{isLoading ? (
					<WalletCollectiblesListSkeleton />
				) : (
					<>
						{favoriteCollectibles?.length === 0 && otherCollectibles?.length === 0 && (
							<WalletNoCollectiblesCard
								onTriggerClick={() =>
									analytics.sendEvent(
										TrackingEventType.track,
										'DigitalCollectibleNotAvailableInfoTooltipClick'
									)
								}
							/>
						)}
						{favoriteCollectibles?.length > 0 && (
							<WalletCollectiblesList
								collectibles={favoriteCollectibles}
								testID="wallet-digitalCollectibles-favoriteListCardItem"
								title={texts.favouriteTeamsTitle}
								onClickCollectible={handleClickDigitalCollectible}
							/>
						)}
						{otherCollectibles?.length > 0 && (
							<WalletCollectiblesList
								collectibles={otherCollectibles}
								testID="wallet-digitalCollectibles-otherListCardItem"
								title={texts.otherTeamsTitle}
								onClickCollectible={handleClickDigitalCollectible}
							/>
						)}
					</>
				)}
			</S.Section>
		</WalletTabContainer>
	);
};

namespace S {
	export const Section = styled.div`
		display: flex;
		flex-flow: column;
		width: 100%;
	`;

	export const Title = styled(Text)`
		text-align: left;
		width: 100%;
	`;
}

export default DigitalCollectibles;
